import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { saveAs } from 'file-saver';

import { SnackBarService } from '../../../../core/services/snackbar.service';
import { LoggerService } from '../../../../core/services/logger.service';
import { IImageType } from '../../../chat/interfaces/IAttachment';

@Component({
  selector: 'ngx-photo-preview',
  templateUrl: './photo-preview.component.html',
  styleUrls: ['./photo-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PhotoPreviewComponent {
  blob: Blob;
  imageTypes: IImageType[] = [
    {
      name: 'image/png',
      type: 'png',
    },
    {
      name: 'image/jpg',
      type: 'jpg',
    },
  ];
  constructor(
    public dialogRef: MatDialogRef<PhotoPreviewComponent>,
    private snackBarService: SnackBarService,
    private logger: LoggerService,
    @Inject(MAT_DIALOG_DATA)
    public data: { url: string; title: string }
  ) {}

  async download(type: IImageType) {
    if (this.blob) {
      this.saveBlob(type, this.blob);
    } else {
      fetch(this.data.url, {})
        .then((response) => response.blob())
        .then((blobDownloaded) => {
          this.saveBlob(type, blobDownloaded);
        })
        .catch((error) => {
          this.snackBarService.showErrorSnackBar('Failed to get Image, please try again');
          this.logger.error(error, 'PhotoPreview.download');
        });
    }
  }

  saveBlob(type: IImageType, blob: Blob): void {
    if (type) {
      this.changeType(blob, type);
    } else {
      saveAs(blob, this.data.title);
    }
  }

  changeType(blob: Blob, type: IImageType): void {
    const url = URL.createObjectURL(blob);
    let title = this.data.title;
    title = title.toLocaleLowerCase().replace('.png', '');
    title = title.toLocaleLowerCase().replace('.jpeg', '');
    title = title.toLocaleLowerCase().replace('.jpg', '');
    title = title.toLocaleLowerCase().replace('.svg', '');
    title = title.toLocaleLowerCase().replace('.bmp', '');
    const img = new Image();
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            saveAs(blob, `${title}.${type.type}`);
          }
        }, type.name);
        URL.revokeObjectURL(url);
      }
    };
    img.onerror = (error) => {
      this.logger.error(error, 'PhotoPreview.changeType');
    };
  }
}
